import { useContext, useEffect, useState } from 'react';
// @ts-ignore
import {
  BreadcrumbGroup,
  Button,
  ColumnLayout,
  Container,
  FormField,
  Header,
  Input,
  SpaceBetween,
} from '@amzn/awsui-components-react/polaris';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import { BREADCRUMBS } from '../../../utils/constants';
import { JUNO_BASE_PATH } from '../../commons/constants';
import { AppContext } from './../../../utils/appContext';

const JunoHomePage = (props: RouteComponentProps) => {
  const appContext = useContext(AppContext);
  const history = useHistory();
  const [hasError, setHasError] = useState(false);
  const [collectionIdentifier, setCollectionIdentifier] = useState('');
  const handleSubmit = () => {
    if (collectionIdentifier == null || collectionIdentifier === '') {
      setHasError(true);
    } else {
      // is collection Identifier Navigate to Details page
      const dom = collectionIdentifier.split(':');
      // Collection id
      if (dom.length === 2) {
        history.push(`${JUNO_BASE_PATH}/${dom[0]}/${dom[1]}/`);
      }
      // Entered value is AccountID navigate to accountId page
      if (
        collectionIdentifier.length === 12 &&
        !Number.isNaN(Number(collectionIdentifier))
      ) {
        // Navigate to account Id, this could be
        history.push(`${JUNO_BASE_PATH}/${collectionIdentifier}/`);
      }
      setHasError(true);
    }
  };
  useEffect(() => {
    appContext.setBreadcrumbs([BREADCRUMBS.JUNO]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <SpaceBetween size="m">
      <BreadcrumbGroup items={appContext.breadcrumbs} />
      <Container header={<Header variant="h2">OpenSearch Serverless</Header>}>
        <SpaceBetween direction="vertical" size="s">
          <ColumnLayout columns={4}>
            <FormField
              constraintText="Provide collection identifier (account-id:collection-id) or account id (12 digit AWS AccountID)"
              label="Collection Identifier"
              errorText={hasError ? 'Provide valid Collection identifier' : ''}
            >
              <Input
                onChange={(event) =>
                  setCollectionIdentifier(event.detail.value.trim())
                }
                value={collectionIdentifier}
                autoFocus
                disableBrowserAutocorrect
              />
            </FormField>
          </ColumnLayout>
          <Button variant="primary" onClick={() => handleSubmit()}>
            Get Details
          </Button>
        </SpaceBetween>
      </Container>
    </SpaceBetween>
  );
};
export { JunoHomePage };
